module.exports = __webpack_public_path__ + "img/SendComment.56998a15.svg";